/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { Clarifer } from "./modelClarifer";

class ControllerClarifer extends ControllerModel {
  constructor() {
    super("ControllerClarifer");
    
    this.setNewNode = (callback) => {
      let clarifer = new Clarifer();
      clarifer.decorate(callback);

      this.addNode(clarifer);
    }

    this.loadNode = (node, callback) => {
      let clarifer = new Clarifer();
      clarifer.copyFrom(node);
      clarifer.decorate(callback);
      this.addNode(clarifer)
    }

    this.getProperties = async (node) => {
      let n = new Clarifer();
      await n.copyFrom(node);
      return n.data
  }

  this.getNode = (node) => {
      let n = new Clarifer();
      n.copyFrom(node);
      return n
  }
  }
}

export { ControllerClarifer };
